import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewStepsCompleted } = appStoreLenses

export default viewStepsCompleted
